<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     模型选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select v-model="devid" :placeholder="placeholder" filterable :clearable="clearable" @change="selectChange" popper-class="f-dev-selector-dropdown" :style="{ width: width + 'px' }">
    <el-option
      v-for="(item, index) in devs"
      :key="index"
      :label="item.dev_name"
      :value="item.devid"
    >
      <div class="dev-select-option flex align-items-center justify-content-space-between">
        <div class="flex align-items-center">
          {{ item.dev_name }}
          <el-tag v-if="item.public === 1" type="blue" class="ml-xs">公开</el-tag>
        </div>
        <div class="dev-type text-muted ml-sm">{{ item.protocal ? item.protocal : ''}}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { getAllDevApi } from '@/api/dev/devApi'

export default {
  name: "FDevSelector",

  props: {
    value: {
      type: [Number, String],
      default: 0
    },

    placeholder: {
      type: String,
      default: '模型'
    },

    width: {
			type: String,
			default: '160'
		},

    showNotLoad: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      devs: []
    }
  },

  computed: {
    devid: {
      get() {
        return this.value || this.value == 0 ? this.value : null
      },
      set(val) {
        this.$emit('input', val || val == 0 ? val : null)
      }
    }
  },

  created() {
    if(this.showNotLoad) {
      this.devs.unshift({devid: 0, dev_name: '未加载'})
    }
    this.fetchData()
  },

  methods: {
    fetchData() {
      getAllDevApi().then(res => {
        if (!res.errno) {
          this.devs = res.data.list
          if(this.showNotLoad) {
            this.devs.unshift({devid: 0, dev_name: '未加载'})
          }
        }
      })
    },

    selectChange(val) {
      const list = this.devs.map(v => v.devid)
      const index = list.indexOf(val)
      const item = this.devs[index]
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss">
.dev-select-option {
  width: 100%;
  .dev-type {
    font-size: 10px;
    color: #8492a6;
  }
}
.f-dev-selector-dropdown {
  .el-tag {
    font-weight: normal;
  }
}
</style>
